exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swiper[data-v-1c47d340] {\n  width: 100%;\n  height: 5.31rem;\n}\n.banner-img[data-v-1c47d340] {\n  width: 100%;\n  height: 5.31rem;\n}\n", ""]);

// exports
